/**
 * TextRunDetailPage — Run-Kopf (`RunDetailHeader`) + Tabs „Braucht deinen
 * Blick"/„Bereit" (T6 → T7 → T8). Kein Count auf dem „Braucht deinen Blick"-Tab:
 * die Suggestions-API liefert kein `total`, nur die aktuelle Seite — ein
 * Count wäre kein billiger Nebeneffekt (s. `RunsListSection.tsx`-Kommentar).
 */
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

import { useContentRun } from './hooks/useContentRun'
import { RunDetailHeader } from './RunDetailHeader'
import { NeedsReviewList } from './review/NeedsReviewList'
import { ReadyBulkList } from './review/ReadyBulkList'

export function TextRunDetailPage({
  backTo = '/v2/tools/text/bulk?tab=runs',
  worklistTo,
}: { backTo?: string; worklistTo?: string } = {}) {
  const { t } = useTranslation()
  const { runId } = useParams<{ runId: string }>()
  const { data } = useContentRun(runId ?? null)
  const run = data?.run

  return (
    <div className="space-y-4 p-6">
      <Link
        to={backTo}
        className="inline-flex items-center gap-1 text-sm text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-300"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('common.back')}
      </Link>

      {run && (
        <>
          <RunDetailHeader run={run} />

          <Tabs defaultValue="needsReview" variant="underline">
            <TabsList>
              <TabsTrigger id={EID['text-bulk-review-tab-needs-review']} value="needsReview">
                {t('channelContent.tabs.needsReview')}
              </TabsTrigger>
              <TabsTrigger id={EID['text-bulk-review-tab-ready']} value="ready">
                {t('channelContent.tabs.ready')}
              </TabsTrigger>
            </TabsList>

            <TabsContent value="needsReview">
              <NeedsReviewList runId={run.id} />
            </TabsContent>

            <TabsContent value="ready">
              <ReadyBulkList runId={run.id} worklistTo={worklistTo} />
            </TabsContent>
          </Tabs>
        </>
      )}
    </div>
  )
}
